module.exports = __webpack_public_path__ + "static/img/jojoexpense.05598c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/jojoexpense.png
// module id = ivvB
// module chunks = 46